<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="month-end-main">
    <div class="left-container">
      <div></div>
      <div class="left-container-content">
        <Input placeholder="Year" :inputValue.sync="txnYear" @focusChanged="changeYear" />

        <BoxContainer title="Branch">
          <div class="BC-MonthEnd">
            <div
              v-for="(n, i) in companyBranch"
              :key="i"
              class="BC-Branch"
              @click="changeBranch(n['CoCode'])"
              :style="{
                cursor: 'pointer',
                backgroundColor: selectedCompanyBranch == n['CoCode'] ? 'rgb(140, 140, 255)' : 'transparent',
              }"
            >
              <div class="BC-Branch-Name"
                >{{ n['Branch Name'] }}{{ n['Department Name'] ? `-${n['Department Name']}` : '' }}</div
              >
            </div>
          </div>
        </BoxContainer>
      </div>
      <div class="left-container-reversed">
        <Dropdown
          placeholder="Document Type"
          :items="docTypeList"
          itemKey="desc"
          @selected="changeDocType"
          :selectedObject.sync="selectedDocType"
        />
        <InputQuery
          placeholder="Document #"
          :items.sync="documentList"
          itemKey="Doc No"
          :selectedObject.sync="selectedDocument"
        />
        <div style="display: flex; justify-content: flex-end">
          <button @click="reverseDocument(true)">Reverse</button>
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="right-top">
        <div class="right-top-month">
          <table class="doc-month-table">
            <thead>
              <tr>
                <th>{{ monthPlaceholder }}</th>
                <th v-for="(dt, dtIndex) in currentModuleDocTypeList" :key="dtIndex">
                  {{ dt['desc'].toUpperCase() }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(month, index) in currentModuleMonthList" :key="index">
                <td>
                  <div style="display: flex; flex-direction: row">
                    <CheckBoxV2
                      :title="month['showMonthName']"
                      :isChecked.sync="month['all']"
                      @checkBoxClicked="checkAll($event, month['month'])"
                    />
                    <img
                      :style="month['allori'] == false ? { visibility: 'hidden' } : {}"
                      src="https://dsmlib.logistics.systems/Icons/Save.png"
                      height="18px"
                    />
                  </div>
                </td>
                <td
                  v-for="(dt, dtIndex) in currentModuleDocTypeList"
                  :key="dtIndex"
                  :style="dt['type'] == 'FAKE' ? { visibility: 'hidden' } : {}"
                >
                  <CheckBoxV2
                    :title="month[`${dt['type']}Date`] ? month[`${dt['type']}Date`] : ''"
                    :isChecked.sync="month[dt['type']]"
                    @checkBoxClicked="checkDocType($event, month['month'], dt['type'])"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="right-top-button">
          <button @click="saveMonthEnd" style="width: 60px">Save </button>
        </div>
      </div>
      <div class="right-bottom">
        <div class="right-bottom-table">
          <TableBox
            title="Reversed Document"
            :tableData="reverseDocList"
            :selectedRow.sync="selectedReverseDoc"
            :hideBottomBlock="true"
            :hideColumns="['txnyear', 'modtype']"
            :maxSelection="-1"
          />
        </div>
        <div class="right-bottom-button">
          <div>
            <button @click="reverseDocument(false)" style="width: 60px">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    docTypeList() {
      if (this.currentModuleDocTypeList) {
        return this.currentModuleDocTypeList.filter(
          (f) => !['AJV', 'CDN', 'EX'].includes(f['type']) && f['type'] != 'FAKE',
        );
      }
      return [];
    },
  },
  data: function () {
    return {
      loginCoCode: '',
      module: '',
      // yearPlaceholder: 'Year',
      txnYear: '',
      fYear: '', //for FINGL usage only
      period: '', //for FINGL usage only; to know Jan period for fyear
      companyBranch: [],
      selectedCompanyBranch: '',
      allowReverse: true,

      monthPlaceholder: 'MONTH',
      monthList: [
        {
          month: '1',
          monthName: 'JANUARY',
          monthsName: 'JAN',
        },
        {
          month: '2',
          monthName: 'FEBRUARY',
          monthsName: 'FEB',
        },
        {
          month: '3',
          monthName: 'MARCH',
          monthsName: 'MAR',
        },
        {
          month: '4',
          monthName: 'APRIL',
          monthsName: 'APR',
        },
        {
          month: '5',
          monthName: 'MAY',
          monthsName: 'MAY',
        },
        {
          month: '6',
          monthName: 'JUN',
          monthsName: 'JUN',
        },
        {
          month: '7',
          monthName: 'JULY',
          monthsName: 'JUL',
        },
        {
          month: '8',
          monthName: 'AUGUST',
          monthsName: 'AUG',
        },
        {
          month: '9',
          monthName: 'SEPTEMBER',
          monthsName: 'SEP',
        },
        {
          month: '10',
          monthName: 'OCTOBER',
          monthsName: 'OCT',
        },
        {
          month: '11',
          monthName: 'NOVEMBER',
          monthsName: 'NOV',
        },
        {
          month: '12',
          monthName: 'DECEMBER',
          monthsName: 'DEC',
        },
      ],
      moduleList: [
        {
          module: 'FINAR',
          docType: [
            {
              type: 'INV',
              desc: 'Invoice',
            },
            {
              type: 'DN',
              desc: 'Debit Note',
            },
            {
              type: 'CN',
              desc: 'Credit Note',
            },
            {
              type: 'RT',
              desc: 'Receipt',
            },
            {
              type: 'AJV',
              desc: 'Journal',
            },
          ],
        },
        {
          module: 'FINPAYMENT',
          docType: [
            {
              type: 'CIN',
              desc: 'AP Invoice',
            },
            {
              type: 'CDN',
              desc: 'AP Debit Note',
            },
            {
              type: 'CCN',
              desc: 'AP Credit Note',
            },
            {
              type: 'EX',
              desc: 'Expenses',
            },
            {
              type: 'PV',
              desc: 'Payment',
            },
          ],
        },
        {
          module: 'FINACCOUNT',
          docType: [
            {
              type: 'CH',
              desc: 'Cheque',
            },
            {
              type: 'CS',
              desc: 'Cash',
            },
            {
              type: 'FAKE', //this fake is just to occupy the remaining column so each column will have same width
              desc: '',
            },
            {
              type: 'FAKE',
              desc: '',
            },
            {
              type: 'FAKE',
              desc: '',
            },
          ],
        },
        {
          module: 'FINGL',
          docType: [
            {
              type: 'JE',
              desc: 'Journal',
            },
            {
              type: 'FAKE', //this fake is just to occupy the remaining column so each column will have same width
              desc: '',
            },
            {
              type: 'FAKE',
              desc: '',
            },
            {
              type: 'FAKE',
              desc: '',
            },
            {
              type: 'FAKE',
              desc: '',
            },
          ],
        },
      ],
      moduleMonthList: [],
      currentModuleMonthList: [],
      currentModuleDocTypeList: [],
      selectedDocType: null,
      documentList: [],
      selectedDocument: null,
      reverseDocList: [],
      selectedReverseDoc: [],

      toUpdate: [],
    };
  },
  props: {},
  methods: {
    async moduleChange(to) {
      this.$fullscreenLoading('Getting Data');
      //reset variables
      this.selectedDocType = null;
      this.selectedReverseDoc = [];
      this.allowReverse = true;

      let pageURL = '';
      //get the route 3rd value for getting the module
      if (to) {
        pageURL = to['path'];
        this.module = pageURL.split('/')[3];
      } else {
        pageURL = this.$route.path;
        this.module = pageURL.split('/')[3];
      }
      // check if change to page is actually month end then only proceed.
      if (pageURL.toUpperCase().endsWith('MONTH END')) {
        //check SAS
        let page = 'Month End';
        if (this.module !== 'FINACCOUNT' && this.module !== 'FINGL') {
          page += ' Process'; //for finaccount and fingl DB accessdescription is month end only
        }
        this.$fullscreenLoading('Checking Security Access');
        const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=${this.module}&page=${page}`);
        if (sasControl && sasControl.length > 0 && sasControl[0]['Control'] == 'MnuReverse') {
          this.allowReverse = sasControl[0]['PropertiesValue'] == 'True';
        }
        this.txnYear = new Date().getFullYear().toString();

        if (this.module == 'FINGL') {
          this.monthPlaceholder = 'MONTH (FYEAR)[PERIOD]';
          this.fYear = (
            await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'FYEAR', txndate: `${this.txnYear}-01-01` })
          )[0]['fyear'];
          this.period = (
            await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
              masterfile: 'PERIOD',
              fyear: this.fYear,
              txndate: `${this.txnYear}-01-01`,
            })
          )[0]['period'];
          if (this.period < 1) {
            //normally period should not be less than 1 unless is a new company and their financial month start at after january and there is no previous fyear in table
            this.fYear = Number(this.fYear) - 1; //minus 1 fyear
            this.period = 12 + Number(this.period); //use december and deduct the period
          }
        } else {
          this.monthPlaceholder = 'MONTH';
        }
        this.fYear = Number(this.fYear);
        this.period = Number(this.period);
        this.moduleMonthList = [];
        this.currentModuleMonthList = [];
        this.currentModuleDocTypeList = [];
        this.moduleMonthList = JSON.parse(JSON.stringify(this.monthList)); //make a copy from the original
        const moduleDetList = this.moduleList.find((f) => f['module'] == this.module.toUpperCase());
        this.currentModuleDocTypeList = moduleDetList['docType']; //make to new array of the selected module doc type
        this.moduleMonthList.forEach((m) => {
          //update the json with additional key value
          (m['all'] = false),
            (m['allori'] = false),
            moduleDetList['docType'].forEach((dt) => {
              m[`${dt['type']}`] = false;
            });
          if (this.module == 'FINGL') {
            if (this.period == 13) {
              this.period = 1;
              this.fYear = this.fYear + 1;
            }
            //fingl purpose
            m['fyear'] = this.fYear;
            m['period'] = this.period;
            this.period++;
            m['showMonthName'] = `${m['monthsName']} (${m['fyear']})[${m['period']}]`;
          } else {
            m['showMonthName'] = m['monthsName'];
          }
        });
        this.$fullscreenLoading('');
        await this.monthEndRefresh();
        await this.getReverseDoc();
      }
    },
    async monthEndRefresh() {
      this.$fullscreenLoading('Getting Month End Data');
      const result = await this.$apiCallV2('/MonthEnd/GetMonthEndList', {
        txnyear: this.txnYear,
        module: this.module,
        type: 'month',
        brcocode: this.selectedCompanyBranch,
      });

      const moduleMonthListCopy = JSON.parse(JSON.stringify(this.moduleMonthList));
      this.currentModuleMonthList = [];
      if (result && moduleMonthListCopy.length > 0) {
        result.forEach((r) => {
          const find = moduleMonthListCopy.find((f) => f['month'] == r['txnmonth']);
          if (find) {
            find[r['modtype']] = r['isclose'] == '1';
            find[`${r['modtype']}oriisclose`] = r['isclose'] == '1'; //for comparing when saving
            find[`${r['modtype']}Date`] = `${r['dateupdate']}(${r['userid']})`;
          }

          find['all'] = Object.keys(find)
            .filter(
              (f) =>
                f != 'all' && f != 'FAKE' && !f.includes('oriisclose') && f != 'allori' && typeof find[f] === 'boolean',
            )
            .every((e) => find[e] == true);
          find['allori'] = find['all'];
        });
      }

      this.currentModuleMonthList = moduleMonthListCopy;
      this.$fullscreenLoading('');
    },
    async getReverseDoc() {
      this.$fullscreenLoading('Getting Reverse Document List');

      this.reverseDocList = [];
      const result = await this.$apiCallV2('/MonthEnd/GetMonthEndList', {
        txnyear: this.txnYear,
        module: this.module,
        type: 'reverse',
        brcocode: this.selectedCompanyBranch,
      });
      if (result) {
        const rvl = result;
        rvl.forEach((f) => {
          f['Doc Type'] = this.currentModuleDocTypeList.find((dt) => dt['type'] == f['modtype'])['desc'];
        });
        this.reverseDocList = rvl;
      }

      this.$fullscreenLoading('');
    },
    async getCompanyBranch() {
      this.$fullscreenLoading('Getting Company Branch');
      //need to update getlistmaster to remove dbname and company server return value security risks
      this.companyBranch = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARENTCOMPANYBRANCH' });
      this.$fullscreenLoading('');
    },
    async saveMonthEnd() {
      if (this.toUpdate && this.toUpdate.length == 0) {
        this.$showAlert('error', 'Close Month End', 'Please select at least 1 month to close or reverse. ');
        return;
      }
      this.$fullscreenLoading('Closing month end');
      const jsonBody = {
        type: 'MONTH',
        txnyear: this.txnYear,
        module: this.module,
        recarr: this.toUpdate,
      };

      const result = await this.$apiCallV2('/MonthEnd/CloseMonthEnd', jsonBody);
      if (result && result[0]['Results'] == '1') {
        this.$showAlert('error', 'Close Month End', `Unable to close month for following. ${result[0]['ErrMsg']}`);
      } else if (result && result[0]['Results'] == '0') {
        await this.monthEndRefresh();
      }
      this.$fullscreenLoading('');
    },
    checkAll(check, month) {
      const find = this.currentModuleMonthList.find((f) => f['month'] == month);
      if (!check && !this.allowReverse) {
        this.$showAlert('warning', 'Unable To Reverse', 'You do not have permission to reverse');
        this.$nextTick(() => {
          // wait till current update cycle finish then only update all to true else will not reflect
          find['all'] = true;
        });
        return;
      }

      if (find) {
        this.toUpdate = JSON.parse(JSON.stringify(this.toUpdate.filter((f) => f['month'] != month))); //remove same month from toupdate
        Object.keys(find).forEach((k) => {
          if (typeof find[k] === 'boolean') {
            if (k != 'allori' && !k.includes('oriisclose')) {
              find[k] = check;
            }

            if (
              k != 'all' &&
              k != 'allori' &&
              !k.includes('oriisclose') &&
              k != 'FAKE' &&
              !find[`${k}oriisclose`] == check
            ) {
              this.toUpdate.push({
                //here will push again data toupdate
                month: month,
                isclose: check ? '1' : '0',
                doctype: k,
                fyear: this.module == 'FINGL' ? find['fyear'] : '',
              });
            }
          }
        });
      }
    },
    checkDocType(check, month, doctype) {
      const find = this.currentModuleMonthList.find((f) => f['month'] == month);
      if (!check && find[`${doctype}oriisclose`] == true && !this.allowReverse) {
        this.$showAlert('warning', 'Unable To Reverse', 'You do not have permission to reverse');
        this.$nextTick(() => {
          // wait till current update cycle finish then only update all to true else will not reflect
          find[`${doctype}`] = true;
        });
        return;
      }
      if (check == true) {
        if (find) {
          const result = Object.keys(find)
            .filter(
              (f) =>
                f != 'all' &&
                f != 'allori' &&
                !f.includes('oriisclose') &&
                f != 'FAKE' &&
                f != doctype &&
                typeof find[f] === 'boolean',
            )
            .every((e) => find[e] == true); //if each doctype key is true then 'all' set to true
          if (result == true) {
            find['all'] = true;
          }
        }
      } else {
        find['all'] = false;
      }
      //push toupdate for saving
      const index = this.toUpdate.findIndex((f) => f['month'] == month && f['doctype'] == doctype);
      if (index != -1) {
        //remove from toUpdate if found
        this.toUpdate.splice(index, 1);
      }
      //then re-add
      if (!find[`${doctype}oriisclose`] == check) {
        this.toUpdate.push({
          //here will push again data toupdate
          month: month,
          isclose: check ? '1' : '0',
          doctype: doctype,
          fyear: this.module == 'FINGL' ? find['fyear'] : '',
        });
      }
    },
    async changeYear(focus) {
      if (!focus) {
        await this.monthEndRefresh();
      }
    },
    async changeBranch(branchcocode) {
      this.selectedCompanyBranch = '';
      //if selected branch is same as the login cocode, then selected company branch need to be empty, that field only for login that is parent company
      if (branchcocode !== this.loginCoCode) {
        this.selectedCompanyBranch = branchcocode;
      }

      await this.monthEndRefresh();
      await this.getReverseDoc();
    },
    async changeDocType(doctype) {
      if (doctype) {
        this.$fullscreenLoading('Getting Document List');
        const result = await this.$apiCallV2('/MonthEnd/GetMonthEndList', {
          txnyear: this.txnYear,
          module: this.module,
          type: 'doc',
          doctype: doctype['type'],
          brcocode: this.selectedCompanyBranch,
        });
        this.documentList = result;
        this.$fullscreenLoading('');
      } else {
        this.documentList = [];
        this.selectedDocument = null;
      }
    },
    async reverseDocument(reverse) {
      if (reverse && !this.selectedDocument) {
        this.$showAlert('error', 'No Document Selected', 'Please select a document to reverse');
        return;
      } else if (!reverse && (!this.selectedReverseDoc || this.selectedReverseDoc.length == 0)) {
        this.$showAlert('error', 'No Document Selected', 'Please select a document to close');
        return;
      }
      this.$fullscreenLoading('Reversing Document');
      const recarr = [];
      if (reverse) {
        recarr.push({
          doctype: this.selectedDocType['type'],
          docno: this.module == 'FINACCOUNT' ? this.selectedDocument['txnid'] : this.selectedDocument['Doc No'],
        });
      } else {
        this.selectedReverseDoc.forEach((rd) => {
          recarr.push({
            doctype: rd['modtype'],
            docno: this.module == 'FINACCOUNT' ? rd['txnid'] : rd['Doc No'],
          });
        });
      }

      const jsonBody = {
        module: this.module,
        type: 'doc',
        txnyear: this.txnYear,
        recarr: recarr.map((m) => {
          return {
            isclose: reverse ? '0' : '1', //here 0 = reverse, 1 = close
            doctype: m['doctype'],
            docno: m['docno'],
          };
        }),
      };

      const result = await this.$apiCallV2('/MonthEnd/CloseMonthEnd', jsonBody);
      this.$fullscreenLoading('');

      if (result && result[0]['Results'] == '1') {
        this.$showAlert('error', 'Reverse Document', `Unable to reverse document. ${result[0]['ErrMsg']}`);
      } else if (result && result[0]['Results'] == '0') {
        this.selectedDocument = null;
        await this.getReverseDoc();
        await this.changeDocType(this.selectedDocType);
      }
    },
  },
  async mounted() {
    const loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.loginCoCode = loginDetails['CoCode'];
    this.getCompanyBranch();
    await this.moduleChange();
  },
  watch: {
    async $route() {
      await this.moduleChange();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.month-end-main {
  padding: 10px 10px 10px 45px;
  display: flex;
  height: 100%;
  font-size: 12px;

  > .left-container {
    border-radius: 5px;
    max-width: 250px;
    min-width: 250px;
    width: 100%;
    height: 100%;
    margin-right: 5px;
    display: flex;
    flex-direction: column;

    > .left-container-content {
      height: 60%;
      background-color: white;
      padding: 5px;
      border-radius: 5px;

      .BC-MonthEnd {
        > .BC-Branch {
          text-align: center;
          display: flex;
          margin-top: 5px;
          padding: 3px;
          border-radius: 5px;
          border: 1px solid black;

          > .BC-Branch-Name {
            width: 90%;
          }
        }
      }
    }

    > .left-container-reversed {
      height: 40%;
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      margin-top: 5px;
    }
  }

  > .right-container {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;

    > .right-top {
      height: 60%;
      background-color: white;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      > .right-top-month {
        width: 100%;
        padding: 5px;
        flex: 1;
        overflow-y: auto;

        > .doc-month-table {
          height: 100%;
          width: 100%;
          table-layout: fixed;

          > tbody tr:hover {
            background-color: rgb(136, 136, 243);
          }

          // td:first-child, th:first-child {
          //   min-width: 10%;
          //   max-width: 10%;
          // }

          // td:not(:first-child), th:not(:first-child) {
          //   min-width: 18%;
          //   max-width: 18%;
          // }
        }
      }

      > .right-top-button {
        display: flex;
        justify-content: flex-end;
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }

    > .right-bottom {
      margin-top: 5px;
      height: 40%;
      background-color: white;
      border-radius: 5px;
      overflow-y: auto;
      padding: 0px 5px 0px 5px;

      display: flex;
      flex-direction: row;

      > .right-bottom-table {
        flex: 1;
      }

      > .right-bottom-button {
        width: 40%;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
      }
    }
  }
}
</style>
